import { Palette, TypeAction } from '@mui/material'

export const palette = {
  members: {
    background: '#F7F0E8',
    backgroundAccent: '#E6F2D9',
    primary: '#102F32',
    accent: {
      main: '#FACE46',
      light: '#FACE46',
      dark: '#FFF3CD',
      text: '#574717'
    },
    input: {
      selected: '#D9B68C',
      hover: '#F9F8F7',
      focus: '#D9B68C'
    },
    button: {
      primary: '#FC5200',
      hover: '#D64600',
      selected: '#D9B68C'
    },
    shadow: '#F2E7D9',
    placeholder: '#B3B3B3',
    stroke: '#D9B68C',
    pill: '#E7E4E0',
    pillIcon: '#AC9E92'
  },
  background: {
    default: '#F7F0E8',
    paper: '#F7F0E8'
  },
  brandPrimary: {
    base: {
      main: '#1C171B',
      light: '#1C171B',
      dark: '#1A7079'
    },
    light: {
      main: '#1C171B',
      light: '#11494F',
      dark: '#11494F'
    },
    dark: {
      main: '#0D363A',
      light: '#0D363A',
      dark: '#0D363A'
    }
  },
  brandSecondary: {
    base: {
      main: '#A6B8B9',
      light: '#A6B8B9',
      dark: '#272C2E'
    },
    darker: {
      main: '#EFE6CF',
      light: '#EFE6CF',
      dark: '#EFE6CF'
    }
  },
  brandText: {
    lightest: {
      main: '#98B7B4',
      light: '#98B7B4',
      dark: '#102F32'
    },
    lighter: {
      main: '#658D89',
      light: '#658D89',
      dark: '#FFFFFF'
    },
    light: {
      main: '#416461',
      light: '#416461',
      dark: '#FFFFFF'
    },
    link: {
      main: '#136EF5'
    },
    base: {
      main: '#1C171B',
      light: '#1C171B',
      dark: '#FFFFFF'
    },
    dark: {
      main: '#07292D',
      light: '#07292D',
      dark: '#B5B5B6'
    },
    darker: {
      main: '#032124',
      light: '#032124',
      dark: '#858586'
    },
    darkest: {
      main: '#151818',
      light: '#151818',
      dark: '#3F3E3E'
    }
  },
  brandGrey: {
    lightest: '#F7F9FA',
    lighter: '#F2F4F5',
    light: '#E7EAEA',
    base: '#D7DDDD',
    dark: '#9DAEAE'
  },
  brandAccent: {
    teaGreen: '#C2D0AE',
    citron: '#EFD482'
  },
  tooltip: {
    surface: '#57626D',
    secondary: '#B8CDCD'
  },
  success: {
    base: '#21BA67',
    light: '#4CD471',
    lighter: '#7DDE86',
    lightest: '#ECFCE5',
    main: '#21BA67',
    dark: '#558D20',
    darkest: '#198155',
    contrastText: '#FFFFFF'
  },
  info: {
    lightest: '#C9F0FF',
    lighter: '#9BDCFD',
    light: '#94CBFF',
    main: '#2F9BE8',
    dark: '#6EC2FB',
    darkest: '#0065D0',
    contrastText: '#FFFFFF'
  },
  warning: {
    lightest: '#FFEFD7',
    light: '#FFE59E',
    main: '#FFBB36',
    dark: '#B86E00',
    darkest: '#C6770C',
    contrastText: '#FFFFFF'
  },
  error: {
    lightest: '#FFE5E5',
    light: '#FA5764',
    main: '#F83342',
    dark: '#D3180C',
    darkest: '#D3180C',
    contrastText: '#FFFFFF'
  },
  chip: {
    primary: '#B8EACD',
    secondary: '#FAE7AF'
  },
  primary: {
    main: '#1C171B',
    light: '#1C171B',
    dark: '#1A7079',
    contrastText: '#FFFFFF'
  },
  secondary: {
    main: '#A6B8B9',
    light: '#A6B8B9',
    dark: '#272C2E',
    contrastText: '#FFFFFF'
  },
  action: {
    active: '#A6B8B9',
    hover: '#A6B8B9'
  } as TypeAction
} as Palette
